<page-header class="text-3xl">Oops! 404!</page-header>

<p>We couldn't find that page. It may be missing or unavailable temporarily.</p>
<p>Sorry. ¯\_(ツ)_/¯</p>
<br>
<text-link onclick="window.history.back()">Take me back!</text-link>
